import type { KPIRequest } from "@/types/kpiTypes.ts"

import { BCOKPIs } from "./bco.ts"
import { ForHireKPIs } from "./forhire.ts"
import { LWRNKPIs } from "./lwrn.ts"
import { PEPLKPIs } from "./pepl.ts"
import { PLTHKPIs } from "./plth.ts"
import { SagepointKPIs } from "./sagepoint.ts"
import { SPLKPIs } from "./spl.ts"

const KPIRequests: Map<number, KPIRequest[]> = new Map()
KPIRequests.set(1, SagepointKPIs)
KPIRequests.set(2, BCOKPIs)
KPIRequests.set(3, SPLKPIs)
KPIRequests.set(4, PLTHKPIs)
KPIRequests.set(5, LWRNKPIs)
KPIRequests.set(6, PEPLKPIs)
KPIRequests.set(7, ForHireKPIs)

export default KPIRequests
